import { createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { Comparer, filterQuickSearchWithTags } from '@common/services/utils.service';
import { Server } from '@apps/bckp/domain/models';
import { BckpConstants } from '@apps/bckp/bckp.constants';
import { getFilterTags } from '@apps/root/store';
import { FilterTag } from '@apps/cmdb/models';

import { getBckpState, IBckpState } from '../bckp.reducer';
import * as fromServersReducer from './servers.reducer';
import * as fromServersServReducer from './serv/serv.reducer';

export const getBckpServersState = createSelector(
    getBckpState,
    (state: IBckpState) =>
        state[fromServersReducer.BckpServersFeatureKey]
);

// #region Servers
export const getBckpServersServState = createSelector(
    getBckpServersState,
    (state: fromServersReducer.IBckpServersState) =>
        state[fromServersServReducer.BckpServersServFeatureKey]
);
export const getBckpServersServQueryString = createSelector(
    getBckpServersServState,
    (state: fromServersReducer.IBckpServersServState) =>
        state.oData.qs
);
export const getServersServIsDataValid = createSelector(
    getBckpServersServState,
    (state) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);

export const getBckpServersServEmptyStatus = createSelector(
    getBckpServersServState,
    (state: fromServersReducer.IBckpServersServState) =>
        state.isEmpty
);

export const getBckpServersServOupsStatus = createSelector(
    getBckpServersServState,
    (state: fromServersReducer.IBckpServersServState) =>
        state.isOups
);
export const getBckpServersServLoadingStatus = createSelector(
    getBckpServersServState,
    (state) =>
        state.isLoading
);
export const getBckpServersServLoadedStatus = createSelector(
    getBckpServersServState,
    (state) =>
        state.isLoaded
);
export const getBckpServersServFilter = createSelector(
    getBckpServersServState,
    (state: fromServersReducer.IBckpServersServState) =>
        state.oData.filter
);

const getBckpServersServCollectionState = createSelector(
    getBckpServersServState,
    (state) =>
        state.collection
);

const {
    selectAll: getAllServers,
} = fromServersReducer.serversServAdapter.getSelectors(getBckpServersServCollectionState);

export const getBckpServersServExportQueryString = createSelector(
    getBckpServersServState,
    (state: fromServersReducer.IBckpServersServState) =>
        state.oData.qsExport
);

const getQuickSearchedServersServ = createSelector(
    getBckpServersServState,
    getAllServers,
    getFilterTags,
    (state: fromServersReducer.IBckpServersServState, servers: Server[], filterTags: FilterTag[]): Server[] =>
        filterQuickSearchWithTags(servers, state.qsWord, BckpConstants.serversServQSFields, filterTags)
);

export const getPipelinedServersServ = (comparer: Comparer<Server>) => createSelector(
    getQuickSearchedServersServ,
    (servers: Server[]): Server[] =>
        servers.sort(comparer)
);

export const getAllServersByIdentifier = (identifier: string) => createSelector(
    getAllServers,
    (servers: Server[]): Server[] =>
        servers.filter((serv: Server): boolean =>
            serv.assetName() === identifier)
);

const getServersServSelectedImages = createSelector(
    getBckpServersServState,
    (state) =>
        state.selectedImages
);
export const {
    selectAll: serversServSelectedImages
} = fromServersReducer.selectedImagesAdapter.getSelectors(getServersServSelectedImages);
// #endregion
